import api from './axiosInstance';

export const optionTypeApi = {
  listConsolidatedOptionTypes: (orgUnitId, category, includeDisabled) =>
    api.get('/stitch-option-types', {params: {
      ...(orgUnitId ? {orgUnitId} : {}),
      ...(category ? {category} : {}),
      ...(includeDisabled ? {includeDisabled: true} : {}),
    }}),

  updateOverride: (globalOptionTypeId, data) =>
    api.put(`/stitch-option-types/${globalOptionTypeId}/override`, data),

  toggleOptionType: (globalOptionTypeId, data) =>
    api.put(`/stitch-option-types/${globalOptionTypeId}/toggle`, data),

  updateOptionOverride: (globalOptionTypeId, globalOptionId, data) =>
    api.put(`/stitch-option-types/${globalOptionTypeId}/options/${globalOptionId}/override`, data),

  toggleOption: (globalOptionTypeId, globalOptionId, data) =>
    api.put(`/stitch-option-types/${globalOptionTypeId}/options/${globalOptionId}/toggle`, data),
};
